const getEventsState = (state) => state && state.eventLog ? state.eventLog : {};
export const eventList = (state) => getEventsState(state).eventList;
export const eventListFilter = (state) => getEventsState(state).eventListFilter;
export const errorMessage = (state) => getEventsState(state).errorMessage;
export const isLoading = (state) => getEventsState(state).isLoading;
export const selectedEvent = (state) => getEventsState(state).selectedEvent;
export const detailDialogOpen = (state) => getEventsState(state).detailDialogOpen;
export const currentPage = (state) => getEventsState(state).currentPage;
export const totalPages = (state) => getEventsState(state).totalPages;
export const totalElements = (state) => getEventsState(state).totalElements;
export const statusCounts = (state) => getEventsState(state).statusCounts;